<template>
  <v-dialog v-model="visible" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title
        class="font-weight-bold"
        style="background: green; color: white"
      >
        Afin d'être rappelé par un de nos experts, veuillez renseigner les
        informations suivantes :
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              v-model="currentProject.serviceWish"
              :items="serviceWish"
              label="Quel service souhaitez-vous ?"
            />
          </v-flex>
          <v-flex xs12 md6>
            <v-select
              v-model="currentProject.contractType"
              :items="contractTypes"
              label="Type de contrat"
            />
          </v-flex>
          <v-flex xs12 md6>
            <v-menu
              ref="menu"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="currentProject.dateMove"
                  prepend-icon="event"
                  v-on="on"
                  label="Date d'emménagement"
                />
              </template>
              <v-date-picker
                v-model="currentProject.dateMove"
                no-title
                scrollable
                :allowed-dates="isInFuture"
              >
                <v-spacer />
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12>
            <vuetify-google-autocomplete
              v-model="currentProject.moveWish"
              id="movewish"
              append-icon="map"
              label="Dans quelle ville souhaitez-vous déménager ?"
              @placechanged="placeChanged"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />

      <v-snackbar v-model="showMessage">
        {{ message }}
      </v-snackbar>

      <v-card-actions class="flex justify-center">
        <v-btn color="primary" text @click="save">
          Valider mes informations
        </v-btn>
        <v-btn @click="visible = false"> Passer </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { CONTRACT_TYPES, SERVICE_WISH } from "../../../../webapp-commons/data";

export default {
  name: "ProjectStarter",
  data() {
    return {
      visible: true,
      showMessage: false,
      message: ""
    };
  },
  computed: {
    currentProject() {
      return this.$store.state.currentProject;
    },
    serviceWish() {
      return SERVICE_WISH;
    },
    contractTypes() {
      return CONTRACT_TYPES;
    }
  },
  methods: {
    isInFuture(date) {
      return moment(date).isAfter();
    },
    placeChanged(data, place) {
      if (data && place) {
        this.currentProject.moveWish = place.formatted_address;
      }
    },
    async save() {
      try {
        await this.$store.dispatch("patchProject", {
          id: this.currentProject._id,
          data: {
            serviceWish: this.currentProject.serviceWish,
            contractType: this.currentProject.contractType,
            dateMove: this.currentProject.dateMove,
            moveWish: this.currentProject.moveWish
          }
        });
      } catch (e) {
        this.message = "Une erreur a eu lieu";
        this.showMessage = true;
        return;
      }

      this.visible = false;
    }
  }
};
</script>

<style scoped></style>
